module.exports = __webpack_public_path__ + "img/unsupported-device.ea1d8e65.svg";